module.exports = __webpack_public_path__ + "assets/img/thumb-SpinTel-Social-Static-Ad.2ae56e3d.webp";